import { ROUTES } from 'constants/routes.js';
import React, { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { toast } from 'utils/toast';
import { EVENTS_MESSAGES } from 'locales/en-US';
import { api } from 'api/api.js';
import Select from 'react-select';
import useLocalStorage from 'hooks';
import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from 'firebase.js';

import {
  StyledSelect,
  SelectContainer,
  StyledLabel,
  // SelectTitles,
  BackgroundImg,
  selectorColors,
} from './style';

export const CustomEventsHeader = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const typeId = searchParams.get('typeId');
  const type = searchParams.get('type');

  // Log google analytics events
  const analytics = getAnalyticsInstance();

  const {
    status: eventStatus,
    data: eventList,
    isLoading: isEventLoading,
  } = useQuery('getEvents', () => api.events.getAllEvents(), {
    onError: () => {
      toast.error(EVENTS_MESSAGES.loadError);

      logEvent(analytics, 'select_content', {
        content_type: 'error',
        content_id: `Loading custom events failed for ${window.location.href}`,
      });
    },
  });

  const getEventFormUrl = (type, typeId) => {
    if (!type && !typeId) return null;
    const event = { label: type, value: typeId };
    return event;
  };

  const [savedEvent, setSavedEvent] = useLocalStorage(
    'chosen-event-type',
    getEventFormUrl(type, typeId)
  );

  const handleEventChange = useCallback(
    (selectedEventType) => {
      setSavedEvent(selectedEventType);

      logEvent(analytics, 'select_content', {
        content_type: 'Changed Custom event',
        content_id: selectedEventType.label,
      });
    },
    [setSavedEvent, analytics]
  );

  // Set default event when events list loads and no event is selected
  useEffect(() => {
    if (
      eventStatus === 'success' &&
      eventList?.data?.length > 0 &&
      !savedEvent
    ) {
      const defaultEvent = {
        label: eventList.data[0].type_name,
        value: eventList.data[0].type_id,
      };
      setSavedEvent(defaultEvent);
    }
  }, [eventStatus, eventList, savedEvent, setSavedEvent]);

  // Navigate when savedEvent changes
  useEffect(() => {
    if (savedEvent?.label && savedEvent?.value) {
      navigate(
        `/${ROUTES.CUSTOM_EVENTS}?type=${savedEvent.label}&typeId=${savedEvent.value}`
      );
    }
  }, [savedEvent, navigate]);

  return (
    <>
      <BackgroundImg $imgUrl="" />
      <SelectContainer $centered={true}>
        <StyledLabel>
          {/* <SelectTitles>Event type</SelectTitles> */}

          {eventStatus === 'success' ? (
            <Select
              components={{ IndicatorSeparator: () => null }}
              defaultValue={savedEvent}
              isDisabled={isEventLoading || !eventList}
              isSearchable={true}
              onChange={handleEventChange}
              options={eventList?.data.map((event) => ({
                label: event.type_name,
                value: event.type_id,
              }))}
              selected={savedEvent}
              styles={StyledSelect}
              theme={{
                colors: selectorColors,
              }}
            />
          ) : null}
        </StyledLabel>
      </SelectContainer>
    </>
  );
};
